export default __webpack_public_path__ + "static/media/TicTacToe.e5eafb42.png";